import React from 'react';
import PropTypes from 'prop-types';
import FilmTile from 'components/FilmTile/FilmTile';
import _ from 'lodash';
import './film-tiles.scss';


const listCinemas = movie => _.uniqBy(
  movie.schedule.map(sche => sche.cinemas.map(sch => ({
    icon: sch.logo,
    name: sch.name,
  }))).flat(1),
  'icon',
);

const FilmTiles = ({ hours, minutes, selectedDate, filteredMovies, width, openModal, activeModal, brandClass, brand }) => (
  <div className="react-film-tiles-container">
    {
      filteredMovies[0]
        ? filteredMovies.map(movie => (
          <FilmTile
            {...movie}
            key={movie.movieId}
            cinemaList={listCinemas(movie)}
            width={width}
            onModalClick={(modal) => { openModal(modal); }}
            tabIndex={movie.movieId}
            activeModal={activeModal}
            hours={hours}
            minutes={minutes}
            selectedDate={selectedDate}
            brandClass={brandClass}
            brand={brand}
          />
        ))
        : <div>Az alábbi szűrési feltételek alapján nem található vetítés.</div>
    }
  </div>
);

FilmTiles.propTypes = {
  hours: PropTypes.number,
  minutes: PropTypes.number,
  brandClass: PropTypes.string,
  selectedDate: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  filteredMovies: PropTypes.arrayOf(PropTypes.shape({})),
  width: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  activeModal: PropTypes.shape({}).isRequired,
  openModal: PropTypes.func.isRequired,
  brand: PropTypes.number.isRequired,
};

FilmTiles.defaultProps = {
  filteredMovies: null,
  hours: new Date().getHours(),
  minutes: new Date().getMinutes(),
  brandClass: 'react-artmozi',
};

export default FilmTiles;
